import {Dialog as MuiDialog, IconButton,} from '@mui/material'
import {Close} from '@mui/icons-material'
import './QuotationDialog.scss'
import QuotationDetail from './QuotationDetail'
import {ServiceRequest} from '../../../../../service/model/ServiceRequest'

function QuotationDialog({
                          className,
                          title,
                          open,
                          onClose,
                          selectedServiceRequest,
                      }: {
    className: string,
    title: string,
    open: boolean,
    onClose: () => void,
    selectedServiceRequest?: ServiceRequest,
}) {

    return (
        <MuiDialog
            open={open}
            onClose={onClose}
            classes={{
                root: 'update-quotation-dialog-root',
                paper: 'update-quotation-dialog-container',
            }}
            className={className}
            onClick = {(event)=>
                event.stopPropagation()
            }
            fullWidth
            maxWidth="lg"
        >
            <div className="update-quotation-dialog">
                <div className="dialog-header">
                    <div className="dialog-title">{title}</div>
                    <IconButton data-testid="close-quotation-dialog" className="dialog-close" onClick={onClose}>
                        <Close/>
                    </IconButton>
                </div>
                <div>
                    {selectedServiceRequest && (
                        <QuotationDetail serviceRequest={selectedServiceRequest}/>
                    )}
                </div>
            </div>
        </MuiDialog>
    )
}

export default QuotationDialog
